<template>
  <div>
    <loader :task="task" />
    <div v-show="!isLoading && !sessionId">
      <message type="warning">
        An issue occurred when connecting to {{ platform }}.
      </message>
      <q-btn
        label="Try again"
        color="primary"
        class="full-width q-mt-md"
        rounded
        @click="start"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import Message from '@/components/message/Message.vue';
import { HasTaskMixin } from '@/mixins';
import { start } from '.';

interface Data {
  task: Promise<number>|null,
}

export default defineComponent({
  emits: ['update:sessionId'],
  mixins: [HasTaskMixin],
  components: {
    Message,
    Loader,
  },
  props: {
    platform: {
      type: String,
      required: true,
    },
    sessionId: Number,
  },
  data(): Data {
    return {
      task: null,
    };
  },
  watch: {
    platform: {
      handler() {
        this.start();
      },
      immediate: true,
    },
  },
  methods: {
    start() {
      this.task = start(this.platform);
      this.task.then((sessionId) => {
        this.$emit('update:sessionId', sessionId);
      });
    },
  },
});
</script>
